import { UserModel } from "@/app/entities";
import { UserTypes } from "../users";

export function getCurrentUserDashboard(user: UserModel): string {
  switch (user.type) {
    case UserTypes.ADMINISTRATEUR:
    case UserTypes.TECHNIQUE:
      return "/dashboard";
    case UserTypes.FOURNISSEUR:
      return "/dashboard/boucles";
    case UserTypes.TERRAIN:
      return "/dashboard/enrolements";
    case UserTypes.PARTICULIER:
    case UserTypes.ENTREPRISE:
      return "/dashboard/campagnes";
    default:
      return "/";
  }
}
